
import Vue from 'vue';
import { mapState } from 'vuex';
import EmptyState from '@/components/states/EmptyState.vue';
import DeploymentImageCard from '@/views/Sessions/DeploymentImagesList/DeploymentImageCard.vue';
import { DeploymentImage, sortDeploymentImages } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'DeploymentImagesList',
	props: {
		appOffer: { type: Object, required: true },
		deploymentImage: { type: Object, default: null },
	},
	computed: {
		...mapState([
			'deploymentImages',
		]),
		filteredDeploymentImages (): DeploymentImage[] {
			return sortDeploymentImages(
				this.deploymentImages.filter((d: DeploymentImage) => d.app === this.appOffer.app),
			);
		},
	},
	components: {
		DeploymentImageCard,
		EmptyState,
	},
});
